import React from "react";
import { Banknote, CreditCard, Building2, FileX2, CheckCircle2 } from "lucide-react";

const MOYENS = [
  { icon: Banknote, label: "Espèces", note: "Acceptées" },
  { icon: CreditCard, label: "Carte bancaire", note: "Sur place" },
  { icon: Building2, label: "Virement", note: "Sur facture" },
];

export const Pricing = () => {
  return (
    <section id="tarifs" className="relative py-24 sm:py-32 bg-[#0F0F0F] border-y border-white/5" data-testid="pricing-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-14">
          <div className="text-[#FFD600] text-xs font-bold tracking-[0.3em] uppercase mb-3">
            — Tarifs & Paiement
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white uppercase tracking-tight">
            Devis clair,<br />
            <span className="text-[#FFD600]">paiement simple.</span>
          </h2>
          <p className="mt-5 text-neutral-400 text-lg max-w-2xl">
            Le tarif dépend du lieu, de la distance et du type de prestation. Je vous donne un prix
            transparent <strong className="text-white">avant intervention</strong> — pas de mauvaise surprise.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5 mb-10">
          {MOYENS.map((m, i) => {
            const Icon = m.icon;
            return (
              <div
                key={i}
                data-testid={`payment-${m.label.toLowerCase().replace(/\s/g, "-")}`}
                className="bg-[#171717] border border-[#262626] rounded-lg p-7 hover:border-[#FFD600]/40 transition-colors"
              >
                <Icon className="w-9 h-9 text-[#FFD600] mb-4" strokeWidth={2} />
                <div className="font-display text-2xl text-white uppercase tracking-tight">{m.label}</div>
                <div className="mt-1.5 inline-flex items-center gap-1.5 text-xs text-emerald-400 font-semibold uppercase tracking-wider">
                  <CheckCircle2 className="w-3.5 h-3.5" />
                  {m.note}
                </div>
              </div>
            );
          })}
        </div>

        {/* Cheques notice */}
        <div
          data-testid="cheque-notice"
          className="bg-[#0A0A0A] border-l-4 border-[#FFD600] rounded-md p-6 flex items-start gap-4"
        >
          <FileX2 className="w-6 h-6 text-[#FFD600] mt-0.5 shrink-0" strokeWidth={2} />
          <div>
            <div className="font-display text-lg text-white uppercase tracking-tight mb-1">
              Chèques non acceptés
            </div>
            <p className="text-neutral-400 text-sm leading-relaxed">
              Sauf paiement émis par un <strong className="text-white">garage partenaire</strong> ou
              une <strong className="text-white">compagnie d'assurance</strong> dans le cadre d'un sinistre.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
